module.exports = __webpack_public_path__ + "media/images/service/b_1-5c5b271eaf4b395d2919dcd6f8c1ff44.png";